<template>
    <div class="custom-modal show-custom-modal" @click="closeModal()">
        <div class="custom-modal-window" @click.stop>

            <div class="btn-close" @click="closeModal()"></div>

            <div class="custom-modal-body">

                <div :class="{ 'd-none' : fetcher.initialized }">
                    <div class="container-fluid">
                        <div class="placeholder-glow w-100">
                            <span class="placeholder bg-info col-18 mb-3 rounded-2" style="height: 34px;"></span>
                            <span class="placeholder bg-info col-24 mb-8 rounded-2" style="height: 48px;"></span>
                            <span class="placeholder bg-info col-18 mb-5 rounded-2" style="height: 45px;"></span>
                            <span class="placeholder bg-info col-18 mb-5 rounded-2" style="height: 45px;"></span>
                        </div>
                    </div>
                </div>

                <div v-if="fetcher.initialized">

                    <div class="container-fluid">

                        <h1>{{ title }}</h1>
                        <p class="mb-8">
                            {{ text }} {{ address.street }} i  {{ address.city }}.
                        </p>

                        <router-link tag="div" class="address-list-item" :key="'lclinic'+clinic.id" :to="{name: 'modal-clinic', params: {clinic: clinic.id}}" v-for="clinic in address.clinics" v-if="clinic.card_name_clinic">
                            <div class="d-flex">
                                <div>
                                    <div class="portrait-wrapper">
                                        <img :src="clinic.portrait.thumb_url" class="portrait" v-if="clinic.portrait" />
                                    </div>
                                </div>
                                <div class="pt-1">
                                    <h4 class="mb-1">{{ clinic.card_name_clinic }}</h4>
                                    <div>
                                        <span v-if="clinic.survey_count > 2 && clinic.show_survey_score === 1" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                        <span v-if="clinic.isNew" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                        <span style="color:#333;">{{ clinic.card_name_person }}</span>
                                    </div>
                                </div>
                            </div>
                        </router-link>

                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import modaler from '../../../shared/mixins/modaler'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        modaler,
        fetcher
    ],

    data () {
        return {
            address: null,
            fetcher: {
                autoFill: [
                    'address'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/addresses/' + this.$route.params.address
        },

        title () {
            const first = this.address.clinics[0]

            if (first.contract_pt) {
                return 'Välj personlig tränare'
            }

            return 'Välj massör'
        },

        text () {
            const first = this.address.clinics[0]

            if (first.contract_pt) {
                return 'Det finns flera personliga tränare på'
            }

            return 'Det finns flera massörer på'
        }
    },

    methods: {

        closeModal () {
            this.$router.push({ name: this.$route.meta.closeTo })
        }

    }
}
</script>
